import { router } from 'expo-router';
import { Pressable, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { AppText } from '@/components/ui/app-text';
import { colors, spacing } from '@/theme/tokens';

interface ScreenHeaderProps {
  title: string;
  /** Optional right-side action (e.g. pencil on goal details). */
  rightIcon?: keyof typeof Ionicons.glyphMap;
  onRightPress?: () => void;
  /** Override the back action (screens opened via replace/onboarding have no history). */
  onBack?: () => void;
}

/** Stack-screen header: back arrow + centered navy title (per Stitch mocks) */
export function ScreenHeader({ title, rightIcon, onRightPress, onBack }: ScreenHeaderProps) {
  // Back must never be a dead no-op: some screens (onboarding invite, deep links)
  // have no history, so router.back() does nothing. Fall back to Start.
  const goBack = () => {
    if (onBack) return onBack();
    if (router.canGoBack()) router.back();
    else router.replace('/(tabs)');
  };
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: spacing.base }}>
      <Pressable
        accessibilityRole="button"
        accessibilityLabel="Wstecz"
        onPress={goBack}
        style={{ minWidth: 44, minHeight: 44, justifyContent: 'center' }}
      >
        <Ionicons name="arrow-back" size={24} color={colors.navy} />
      </Pressable>
      <AppText variant="headlineMd" color={colors.navy} style={{ flex: 1, textAlign: 'center' }}>
        {title}
      </AppText>
      {rightIcon && onRightPress ? (
        <Pressable
          accessibilityRole="button"
          onPress={onRightPress}
          style={{ minWidth: 44, minHeight: 44, alignItems: 'flex-end', justifyContent: 'center' }}
        >
          <Ionicons name={rightIcon} size={22} color={colors.navy} />
        </Pressable>
      ) : (
        <View style={{ minWidth: 44 }} />
      )}
    </View>
  );
}
